import api from './api';

const getMarcapassoById = async id => {
  const response = await api.get(`/marcapasso/${id}`);
  return response.data;
};

export default getMarcapassoById;
